/** Mirrors backend pricing: ₦1,500 base + ₦100 per kg */
export const calcAmount = (packageWeight?: number): number => {
    const base = 1500;
    const weight = packageWeight && packageWeight > 0 ? packageWeight : 0;
    return base + weight * 100;
};

interface Props {
    packageWeight?: number;
}

const BillSummary = ({ packageWeight }: Props) => {
    const amount = calcAmount(packageWeight);
    const weightCharge = (packageWeight ?? 0) > 0 ? (packageWeight ?? 0) * 100 : 0;

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Base fee</span>
                <span className="font-bold text-slate-700">₦1,500</span>
            </div>
            {weightCharge > 0 && (
                <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-500">Weight ({packageWeight} kg × ₦100)</span>
                    <span className="font-bold text-slate-700">₦{weightCharge.toLocaleString('en-NG')}</span>
                </div>
            )}
            <div className="h-px bg-slate-100" />
            <div className="flex items-center justify-between">
                <span className="text-base font-black text-slate-800">Total</span>
                <span className="text-base font-black text-primary">₦{amount.toLocaleString('en-NG')}</span>
            </div>
        </div>
    );
};

export default BillSummary